export default "__VITE_ASSET__BLhWOPqh__"